var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0301 3.73314C13.5049 4.19978 13.047 4.61856 12.5756 5.02538C9.41063 7.8372 6.23219 10.661 3.06722 13.4728C2.27261 14.1787 1.16823 14.1668 0.454432 13.4728C-0.0977553 12.9344 -0.151625 12.1327 0.319754 11.5464C0.41403 11.4268 0.521773 11.3191 0.642985 11.2233C4.64297 7.66968 8.62949 4.12799 12.6295 0.574328C13.4914 -0.191444 14.5015 -0.191444 15.3635 0.574328C19.3769 4.13995 23.3904 7.69362 27.4038 11.2592C28.2927 12.0489 28.1715 13.2215 27.1479 13.7719C26.5149 14.107 25.7742 14.0711 25.1951 13.6762C25.0873 13.5925 24.9796 13.5087 24.8718 13.413C21.3432 10.2781 17.8146 7.15518 14.2995 4.0203C14.2052 3.93655 14.1379 3.84083 14.0301 3.73314Z",
    fill: "#CF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/Chevron-Down.df01d11400d975191127d1dd6680e16a.svg";
export { ForwardRef as ReactComponent };